import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Link from '@mui/material/Link'; 
import { useParams, useNavigate } from 'react-router-dom';

export default function Legal() {
    const { location = "india" } = useParams();
    const navigate = useNavigate();
    const handleChange = (event) => {
        navigate(`/legal/${event.target.value}`);
    };

    React.useEffect(() => {
        if(!['eu', 'india'].includes(location)) {
            navigate('/legal/india');
        }
        const termsAndConditionsView = document.getElementById('TermsAndConditons');
        if (termsAndConditionsView) {
            termsAndConditionsView.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);
  
    return (
        <Container id="TermsAndConditons" sx={{ 
            my: { sm: 0, xs: 5 },
            py: { sm: 16, xs: 12 }
        }} fixed>
            <Box sx={{  minHeight: '50vh' }}>
                <Typography variant="h1" component="h1" align="center">
                    Terms and Conditions
                </Typography>
                <Box textAlign="center">
                    <FormControl sx={{ my: { sm: 4, xs: 2 }, minWidth: 120 }} variant="outlined">
                        <Select
                            labelId="location-terms-and-conditions"
                            id="location-terms-and-conditions"
                            value={location}
                            onChange={handleChange}
                            autoWidth
                            label="Location"
                        >
                        <MenuItem value={'eu'}>Europe</MenuItem>
                        <MenuItem value={'india'}>India</MenuItem>
                        </Select>
                    </FormControl>
                    <Typography variant="body1" align="center">
                        Terms and Conditions as shown as per selected location above.
                    </Typography>
                    <Typography variant="h2" component="h2" align="left" gutterBottom={true}>
                        <b>imprint</b>
                    </Typography>
                    {location === 'eu' ? <>
                        <Typography variant="body1" align="left">
                            <b>Person responsible:</b>
                            <br/>
                            Aliatis OÜ
                            <br/>
                            Harju maakond, Tallinn, Kesklinna linnaosa, Ravi tn 7-2, 10134, Estonia
                        </Typography>
                        <br/>
                        <Typography variant="body1" align="left">
                        Telephone: <b>+4915779158908</b> Email: <Link href="mailto:contact@aliatis.io">
                        contact@aliatis.io
                        </Link>
                        <br/>
                        <br/>
                        Authorized managing directors: Shubham Tukaram Chodankar
                        <br/>
                        <br/>
                        Registration: registration code <b>17134029</b> is listed in the Commercial Register of Estonia, maintained by the Registration Department of Tartu County Court, under registry card no. 1.
                        <br/>
                        </Typography>
                    </> : <>
                        <Typography variant="body1" align="left">
                            <b>Person responsible:</b>
                            <br/>
                            ATISALISTECH SOLUTIONS PRIVATE LIMITED
                            <br/>
                            H.NO. 323/1F17 NR. GANAPATI TEMPLE, GANAPATIWADA KHANDOLA GOA 403107, INDIA
                        </Typography>
                        <br/>
                        <Typography variant="body1" align="left">
                            Telephone: <b>+918975567457</b> Email: <Link href="mailto:contact@aliatis.io">
                            contact@aliatis.io
                        </Link>
                        <br/>
                        <br/>
                        Authorized managing directors: Shubham Tukaram Chodankar
                        <br/>
                        <br/>
                        Registration: The Corporate Identity Number(CIN) <b>U70200GA2025PTC017067</b> is  registered with Government of India, Ministry of Corporate Affairs
                        <br/>
                        </Typography>
                    </>}
                </Box>
            </Box>
        </Container>
    );
}